import { Box, Typography } from '@mui/material';
import { JsonEditor } from 'json-edit-react';
import { useController } from 'react-hook-form';

export type JsonInputProps = {
  source: string;
  label?: string;
};

export const JsonInput = ({ source, label }: JsonInputProps) => {
  const { field } = useController({ name: source, defaultValue: '' });

  return (
    <Box>
      {label && (
        <Typography variant="body2" color="text.secondary" mb={1}>
          {label as string}
        </Typography>
      )}
      <JsonEditor
        data={field.value as any}
        setData={field.onChange}
        // onBlur={field.onBlur}
      />
    </Box>
  );
};
